import React, { useState, useEffect } from 'react';
import {
  Page,
  Layout,
  Card,
  Text,
  BlockStack,
  InlineStack,
  Badge,
  Button,
  Divider,
  Box,
  Icon,
} from '@shopify/polaris';
import { NoteIcon } from '@shopify/polaris-icons';
import { useNavigate } from 'react-router-dom';
import { api } from '../api';

export default function Dashboard() {
  const navigate = useNavigate();
  const [stats, setStats] = useState({ quotes: 0, salespersons: 0 });
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    Promise.all([
      api.get('/api/quotes'),
      api.get('/api/salespersons')
    ])
      .then(([quotesRes, salespersonsRes]) => {
        console.log('[Dashboard] Quotes response:', quotesRes.data);
        console.log('[Dashboard] Salespersons response:', salespersonsRes.data);
        
        // Quotes API returns: { success: true, data: [...] }
        const quotesData = quotesRes.data?.data || [];
        
        // Salespersons API returns: { data: [...], pagination: {...} }
        const salespersonsData = salespersonsRes.data?.data || [];
        
        setStats({
          quotes: quotesData.length,
          salespersons: salespersonsData.length,
        });
      })
      .catch((err) => {
        console.error('[Dashboard] Error fetching stats:', err);
        setStats({ quotes: 0, salespersons: 0 });
      })
      .finally(() => setLoading(false));
  }, []);

  return (
    <Page
      title="Request For Quote"
      subtitle="Manage quote requests from your customers"
    >
      <Layout>
        {/* Quote Requests Card */}
        <Layout.Section>
          <InlineStack gap="400" wrap>
            <Box minWidth="200px" flex="1">
              <Card>
                <BlockStack gap="300">
                  <InlineStack align="space-between" blockAlign="center">
                    <Text variant="headingMd" as="h3" tone="subdued">Quote Requests</Text>
                    <Icon source={NoteIcon} tone="critical" />
                  </InlineStack>
                  <Text variant="heading2xl" as="p" fontWeight="bold">
                    {loading ? '—' : stats.quotes}
                  </Text>
                  <Button variant="plain" onClick={() => navigate('/quotes')}>View Quotes</Button>
                </BlockStack>
              </Card>
            </Box>
            <Box minWidth="200px" flex="1">
              <Card>
                <BlockStack gap="300">
                  <InlineStack align="space-between" blockAlign="center">
                    <Text variant="headingMd" as="h3" tone="subdued">Salespersons</Text>
                    <Icon source={NoteIcon} tone="info" />
                  </InlineStack>
                  <Text variant="heading2xl" as="p" fontWeight="bold">
                    {loading ? '—' : stats.salespersons}
                  </Text>
                  <Button variant="plain" onClick={() => navigate('/salesperson-routing')}>Manage Salespersons</Button>
                </BlockStack>
              </Card>
            </Box>
          </InlineStack>
        </Layout.Section>
      </Layout>
    </Page>
  );
}
